/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgNeutral32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        fill='currentColor'
        d='M11 21h2.326v-5.634c0-.479 0-.915-.014-1.338h.043c.141.338.425.789.666 1.17L18.361 21H21V11h-2.326v6.944h-.029a7.563 7.563 0 00-.68-1.212L13.78 11H11v10z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M2.25 7A4.75 4.75 0 017 2.25h18A4.75 4.75 0 0129.75 7v18A4.75 4.75 0 0125 29.75H7A4.75 4.75 0 012.25 25V7zM7 3.75A3.25 3.25 0 003.75 7v18A3.25 3.25 0 007 28.25h18A3.25 3.25 0 0028.25 25V7A3.25 3.25 0 0025 3.75H7z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M25.25 24v-1.333h1.5V24A2.75 2.75 0 0124 26.75h-2.444v-1.5H24c.69 0 1.25-.56 1.25-1.25zM16 25.25h3.333v1.5H16v-1.5zM6.75 8v2h-1.5V8A2.75 2.75 0 018 5.25h3v1.5H8c-.69 0-1.25.56-1.25 1.25z'
      />
    </svg>
  );
}

export default SvgNeutral32;
